import { useQueryClient, useQuery, useMutation } from '@tanstack/react-query';
import { notification, Row, Col, Button, Input, Form, Upload, UploadFile, UploadProps } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import React, { useState } from 'react'
import { postArticleCreate, postPhotos } from '../../../services/api';
import PageTitle from '../../../components/page-title';
import { RcFile } from 'antd/es/upload';

const PhotosCreate = () => {

  const [fileList, setFileList] = useState<UploadFile[]>([]);
  const [description, setDescription] = useState("");

  const queryClient = useQueryClient();
  const [ ntf, contextHolder ] = notification.useNotification();
  const { mutate: mutatePostPhotos, isLoading: isLoadingPostPhotos } = useMutation(postPhotos);

  const handleUpload = () => {
    const formData = new FormData();
    fileList.forEach((file) => {
      formData.append('photo_name[]', file as RcFile);
      formData.append('description', description);
    });
    mutatePostPhotos(formData, {
      onSuccess() {
          queryClient.invalidateQueries(['photos']);
          ntf.success({
              message: `Success`,
              description: "Uploaded with success!",
              placement: "bottomLeft",
          });
          setFileList([]);
      },
      onError() {
          ntf.error({
              message: `Error`,
              description: "Something gonne wrong!",
              placement: "bottomLeft",
          });
      },
    })
  }

  const props: UploadProps = {
    accept: ".png,.jpeg,.jpg,.webp",
    multiple: true,
    onRemove: (file) => {
      const index = fileList.indexOf(file);
      const newFileList = fileList.slice();
      newFileList.splice(index, 1);
      setFileList(newFileList);
    },
    beforeUpload: (file) => {
      setFileList([...fileList, file]);
      return false;
    },
    fileList,
  };
  
  
  return (
      <Row justify="center">
          {contextHolder}
          <PageTitle text={`Photo Upload`} />
          <Col span={20}>
              <Row gutter={16}>
                  <Col span={24}>
                      <Form
                          name="photo_upload"
                          style={{ width: "100%"}}
                          layout="vertical"
                      >
                          <Form.Item
                              label="Name of the photo or collection of the photos goes here"
                              name="description"
                          > 
                              <Input placeholder='Hakija rozi macak u cizmama' onChange={(e: any) => setDescription(e.target.value)} />
                          </Form.Item>
                          <Form.Item
                              label="Select photo or list of photo here:"
                          > 
                              <Upload {...props}>
                                <Button icon={<UploadOutlined />}>Select File</Button>
                              </Upload>
                          </Form.Item>
                          <Form.Item>
                            <Button
                              type="primary"
                              onClick={handleUpload}
                              disabled={fileList.length === 0}
                              loading={isLoadingPostPhotos}
                              style={{ marginTop: 16 }}
                            >
                              {isLoadingPostPhotos ? 'Uploading' : 'Start Upload'}
                            </Button>
                          </Form.Item>
                      </Form>
                  </Col>
              </Row>
          </Col>
      </Row>
    )
}

export default PhotosCreate